import { z } from "zod";
import { TopolSectionSchema } from "../templateSchema";
import { TopolSpecialBlockTranslationSchema } from "../template/languageSchema";

export const SavedBlockApiSchema = z.object({
  id: z.number(),
  name: z.string(),
  definition: TopolSectionSchema.optional(),
  image: z.string().optional(),
  created_at: z.string().optional(),
  type: z.enum(["folder", "saved_section", "synced_section"]),
  folder_id: z.number().optional(),
  new: z.boolean().optional(),
  translation: TopolSpecialBlockTranslationSchema.optional().catch(undefined),
});
export const SavedBlocksApiSchema = z.array(SavedBlockApiSchema);

export type ISavedBlockApi = z.infer<typeof SavedBlockApiSchema>;

export type ISavedBlocksSortBy = "name" | "date" | "type";

export const SavedBlocksPathSchema = z.object({
  id: z.number(),
  name: z.string(),
});
export type ISavedBlocksPath = z.infer<typeof SavedBlocksPathSchema>;

export const EditParamsSchema = z.object({
  entity_id: z.string(),
  hostname: z.string(),
  key: z.string(),
  definition: TopolSectionSchema.optional(),
  name: z.string().optional(),
  type: z.enum(["folder", "saved_section", "synced_section"]).optional(),
  folder_id: z.number().nullable().optional(),
  translation: TopolSpecialBlockTranslationSchema.optional().catch(undefined),
});
export type IEditParams = z.infer<typeof EditParamsSchema>;
